import type { AiChatPrompt } from '../aiChatPromptTypes';

export const netWorthPrompts: AiChatPrompt[] = [
  {
    displayPrompt: '📈 How has my net worth changed?',
    actualPrompt:
      '📈 How has my net worth changed? Compare my current net worth to the previous month and show the trend over the selected date range, highlighting the biggest contributors to any increase or decrease.',
  },
  {
    displayPrompt: "💰 What's driving my assets?",
    actualPrompt:
      "💰 What's driving my assets? Break down my assets by account and category, identify which accounts grew or declined the most, and explain what is driving those changes.",
  },
  {
    displayPrompt: '📉 Am I reducing debt over time?',
    actualPrompt:
      '📉 Am I reducing debt over time? Analyze my debt balances over the selected period, show whether total debt is trending down, and highlight which debt accounts are improving or getting worse.',
  },
  {
    displayPrompt: '🏦 Which accounts matter most?',
    actualPrompt:
      '🏦 Which accounts matter most? Identify the accounts that contribute most to my net worth and explain how each one affects my overall financial picture.',
  },
  {
    displayPrompt: '⚖️ How healthy is my debt ratio?',
    actualPrompt:
      '⚖️ How healthy is my debt ratio? Calculate my debt-to-asset ratio, compare it to recent trends, and explain whether my current balance between assets and debt looks healthy.',
  },
  {
    displayPrompt: '🚀 How can I grow net worth faster?',
    actualPrompt:
      '🚀 How can I grow net worth faster? Based on my current assets, debt, and spending patterns, suggest practical steps I can take to improve my net worth over the next few months.',
  },
  {
    displayPrompt: '💵 Cash vs investments split?',
    actualPrompt:
      '💵 Cash vs investments split? Show how my net worth is divided between cash and cash-equivalent accounts versus investment accounts, and explain whether the current mix aligns with my financial situation.',
  },
  {
    displayPrompt: '📆 How does this year compare?',
    actualPrompt:
      '📆 How does this year compare? Compare my net worth today to the same point last year, break down year-over-year changes by assets and debt, and highlight the biggest drivers of growth or decline.',
  },
  {
    displayPrompt: '🔀 Biggest monthly swing?',
    actualPrompt:
      '🔀 Biggest monthly swing? Identify the month with the largest net worth change in the selected period, explain what caused that swing, and note whether it was driven by assets, debt, or a specific account.',
  },
  {
    displayPrompt: '💧 How liquid are my assets?',
    actualPrompt:
      '💧 How liquid are my assets? Estimate how much of my net worth is in readily accessible liquid assets versus less liquid holdings, and explain what that means for my financial flexibility.',
  },
  {
    displayPrompt: '🏖️ Retirement share of net worth?',
    actualPrompt:
      '🏖️ Retirement share of net worth? Calculate what percentage of my net worth is held in retirement accounts, compare that share to my other assets, and note whether retirement savings are on track relative to my total wealth.',
  },
  {
    displayPrompt: '💳 Credit card debt trend?',
    actualPrompt:
      '💳 Credit card debt trend? Track my credit card balances over the selected period, show whether total credit card debt is rising or falling, and flag any cards that are driving the trend.',
  },
  {
    displayPrompt: '🐷 How much is savings adding?',
    actualPrompt:
      '🐷 How much is savings adding? Measure how much my savings and cash accounts have contributed to net worth growth over the selected period, and compare savings growth to investment and debt changes.',
  },
  {
    displayPrompt: '⚡ Assets vs liabilities balance?',
    actualPrompt:
      '⚡ Assets vs liabilities balance? Compare total assets to total liabilities, show how each side has changed over time, and explain whether my balance sheet is strengthening or weakening.',
  },
  {
    displayPrompt: '🛡️ Emergency fund as % of NW?',
    actualPrompt:
      '🛡️ Emergency fund as % of NW? Estimate my emergency fund based on liquid savings accounts, express it as a percentage of my net worth, and assess whether that level provides adequate coverage.',
  },
  {
    displayPrompt: '🏠 How does real estate affect NW?',
    actualPrompt:
      '🏠 How does real estate affect NW? Identify property or real estate accounts in my net worth, show how much they contribute to total assets, and explain how property value changes have affected my net worth over time.',
  },
  {
    displayPrompt: '📊 Investment gains vs losses?',
    actualPrompt:
      '📊 Investment gains vs losses? Break down how investment account performance has affected my net worth, separating unrealized gains from losses, and identify which investment accounts had the largest impact.',
  },
  {
    displayPrompt: '🗓️ What changed this month?',
    actualPrompt:
      '🗓️ What changed this month? Summarize net worth changes from the start of this month to now, listing the top accounts that increased or decreased in value and the net effect on my overall net worth.',
  },
  {
    displayPrompt: '🏁 Assets vs debt growth race?',
    actualPrompt:
      '🏁 Assets vs debt growth race? Compare how fast my total assets and total debt have grown over the selected period, and explain whether asset growth is outpacing debt accumulation.',
  },
  {
    displayPrompt: '⏱️ How fast is NW growing?',
    actualPrompt:
      '⏱️ How fast is NW growing? Calculate my net worth growth rate over the selected period, express it as a monthly or annualized pace, and compare recent velocity to earlier periods to show whether growth is accelerating or slowing.',
  },
  {
    displayPrompt: '📈 What caused the recent change in my net worth?',
    actualPrompt:
      '📈 Which account or account type caused the largest change to my net worth - up and down - in the past 3 months.',
  },
  {
    displayPrompt: '🔮️ Project my net worth in 10 years',
    actualPrompt:
      '🔮️ Using the change in my net worth, project what my net worth will be in 10 years, explaining how you did calculated.',
  },
  {
    displayPrompt: '💰 When will I reach $1 million?',
    actualPrompt:
      '💰 Using my current net worth and past growth, estimate in how many years my total net worth will reach $1,000,000, if it all, in the next 60 years.',
  },
  {
    displayPrompt: '✈️ How much runway do I have?',
    actualPrompt:
      '✈️ Using my monthly spend, calculate how much runway I currently have in liquid assets from today onward, expressed in months. Is this good?',
  },
];
